import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-0" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "font-weight-normal d-block" }
const _hoisted_4 = { class: "d-flex flex-column mx-1" }
const _hoisted_5 = { class: "d-flex justify-content-between flex-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = { class: "font-weight-bold mb-0" }
const _hoisted_9 = { class: "d-flex align-items-start" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "ml-1" }
const _hoisted_17 = { class: "text-bold mb-0" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "ml-1" }
const _hoisted_24 = { class: "text-bold mb-0" }
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = { class: "text-info" }
const _hoisted_27 = { class: "d-flex align-items-start" }
const _hoisted_28 = { class: "mb-1" }
const _hoisted_29 = { class: "d-flex align-items-start" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = {
  key: 1,
  class: "flex align-items-center flex-column"
}
const _hoisted_32 = {
  key: 2,
  class: "pl-1 pt-2 d-flex flex-column"
}
const _hoisted_33 = { class: "country-item" }
const _hoisted_34 = { class: "mt-2" }
const _hoisted_35 = { class: "d-flex align-items-start" }
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = {
  key: 1,
  class: "flex align-items-center flex-column"
}
const _hoisted_38 = {
  key: 2,
  class: "pl-1 pt-2 d-flex flex-column"
}
const _hoisted_39 = { class: "mt-1" }
const _hoisted_40 = { class: "p-inputgroup mb-2" }
const _hoisted_41 = { class: "d-flex" }
const _hoisted_42 = { class: "mb-0 mr-1 text-bold" }
const _hoisted_43 = { class: "mb-0" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_45 = { class: "mt-2" }
const _hoisted_46 = { class: "d-flex align-items-start" }
const _hoisted_47 = { class: "mb-1" }
const _hoisted_48 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = { class: "mr-1 mb-0" }
const _hoisted_51 = { class: "d-flex align-items-start" }
const _hoisted_52 = { class: "mb-1" }
const _hoisted_53 = {
  key: 0,
  class: "pl-1 pt-2 d-flex flex-column"
}
const _hoisted_54 = { class: "mt-2" }
const _hoisted_55 = {
  key: 1,
  class: "flex align-items-center flex-column"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ExpertOverviewForm = _resolveComponent("ExpertOverviewForm")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_ExpertExperienceForm = _resolveComponent("ExpertExperienceForm")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ExpertLevelModal = _resolveComponent("ExpertLevelModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showCompletionSteps)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          class: "message-with-button",
          closable: false,
          severity: "custom"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.vm.stepsTitle), 1),
              _createElementVNode("span", {
                class: "font-weight-normal mb-1",
                innerHTML: _ctx.vm.steps[_ctx.activeStepIndex]?.text
              }, null, 8, _hoisted_2),
              _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.$t("common.stepXOfY", [_ctx.activeStepIndex + 1, _ctx.vm.steps.length])), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.activeStepIndex > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-sm p-button-text flex-shrink-0",
                    label: _ctx.$t('common.previous'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeStepIndex--))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.activeStepIndex < _ctx.vm.steps.length - 1)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "p-button-sm flex-shrink-0",
                    label: _ctx.$t('common.nextStep'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeStepIndex++))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.vm.pageTitle)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.vm.pageTitle), 1))
        : _createCommentVNode("", true),
      (_ctx.isProfileApproved && _ctx.expertProfile?.contentLinkUrl)
        ? (_openBlock(), _createBlock(_component_LinkButton, {
            key: 1,
            class: "flex-shrink-0 p-button-text",
            icon: "pi pi-external-link",
            label: _ctx.$t('myCadac.expertProfile.btnViewProfile'),
            target: "_blank",
            url: _ctx.expertProfile?.contentLinkUrl
          }, null, 8, ["label", "url"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("myCadac.expertSettings.titleChooseLanguage")), 1),
      _createVNode(_component_LanguageDropdown, {
        languages: _ctx.availableLanguages,
        onLanguageSelected: _ctx.onProfileLanguageChanged
      }, null, 8, ["languages", "onLanguageSelected"])
    ]),
    _createVNode(_component_Panel, { class: "mb-2" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("myCadac.expertSettings.titleExpertLevel")), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.expertProfile?.expertLevelProduct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("myCadac.expertSettings.lblCurrentLevel")), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_PopoverIcon, {
                    "open-delay": 500,
                    placement: "right"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("p", {
                        class: "text-bold mb-0",
                        innerHTML: _ctx.expertProfile?.expertLevelProduct?.displayName
                      }, null, 8, _hoisted_14),
                      _createElementVNode("div", {
                        innerHTML: _ctx.expertProfile?.expertLevelProduct?.description
                      }, null, 8, _hoisted_15)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Avatar, {
                        alt: _ctx.expertProfile?.expertLevelProduct?.iconAlt,
                        image: _ctx.expertProfile?.expertLevelProduct?.iconUrl,
                        shape: "square",
                        size: "large"
                      }, null, 8, ["alt", "image"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.expertProfile?.expertLevelProduct?.displayName), 1),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("expert.expertLevelHourlyPriceRange", [
									_ctx.formatCurrency(_ctx.expertProfile?.expertLevelProduct?.minPrice),
									_ctx.formatCurrency(_ctx.expertProfile?.expertLevelProduct?.maxPrice),
								])), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.expertProfile?.expertLevelProduct)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "p-button-success",
                label: _ctx.$t('myCadac.expertSettings.btnChooseLevel'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expertStore.showModal('ExpertLevel')))
              }, null, 8, ["label"]))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                class: "p-button-text px-0",
                label: _ctx.$t('myCadac.expertSettings.btnChooseOtherLevel'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expertStore.showModal('ExpertLevel')))
              }, null, 8, ["label"])),
          (_ctx.expertProfile?.requestedLevelProduct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("myCadac.expertSettings.lblRequestedLevel")), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_PopoverIcon, {
                    "open-delay": 500,
                    placement: "right"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("p", {
                        class: "text-bold mb-0",
                        innerHTML: _ctx.expertProfile?.requestedLevelProduct?.displayName
                      }, null, 8, _hoisted_21),
                      _createElementVNode("div", {
                        innerHTML: _ctx.expertProfile?.requestedLevelProduct?.description
                      }, null, 8, _hoisted_22)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Avatar, {
                        alt: _ctx.expertProfile?.requestedLevelProduct?.iconAlt,
                        image: _ctx.expertProfile?.requestedLevelProduct?.iconUrl,
                        shape: "square",
                        size: "large"
                      }, null, 8, ["alt", "image"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.expertProfile?.requestedLevelProduct?.displayName), 1),
                    _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("expert.expertLevelHourlyPriceRange", [
									_ctx.formatCurrency(_ctx.expertProfile?.requestedLevelProduct?.minPrice),
									_ctx.formatCurrency(_ctx.expertProfile?.requestedLevelProduct?.maxPrice),
								])), 1),
                    _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.$t("myCadac.expertSettings.message.awaitingExpertLevelApproval")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { class: "mb-2" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t("myCadac.expertSettings.titleOverview")), 1)
        ])
      ]),
      icons: _withCtx(() => [
        (!_ctx.isEditingExpertOverview)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-text px-0",
              icon: "pi pi-pencil",
              label: _ctx.$t('common.edit'),
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.isEditingExpertOverview = true), ["stop"]))
            }, null, 8, ["label"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "p-button-text p-button-primary",
              label: _ctx.$t('common.cancel'),
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.isEditingExpertOverview = false), ["stop"]))
            }, null, 8, ["label"]))
      ]),
      default: _withCtx(() => [
        (!_ctx.isEditingExpertOverview && _ctx.hasEmptyOverview)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              closable: false,
              severity: "warn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.message.noOverview")), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_ExpertOverviewForm, {
              key: 1,
              "is-editing": _ctx.isEditingExpertOverview,
              vm: _ctx.expertProfile,
              onSubmit: _ctx.saveExpertOverview
            }, null, 8, ["is-editing", "vm", "onSubmit"]))
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { class: "mb-2" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.$t("myCadac.expertSettings.titleLanguages")), 1)
        ])
      ]),
      icons: _withCtx(() => [
        (!_ctx.isEditingExpertLanguages)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-text",
              icon: "pi pi-pencil",
              label: _ctx.$t('common.edit'),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isEditingExpertLanguages = true))
            }, null, 8, ["label"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "p-button-text p-button-primary",
              label: _ctx.$t('common.cancel'),
              onClick: _cache[7] || (_cache[7] = ($event: any) => {
					_ctx.isEditingExpertLanguages = false;
					_ctx.initLanguages();
				})
            }, null, 8, ["label"]))
      ]),
      default: _withCtx(() => [
        (!_ctx.isEditingExpertLanguages && !_ctx.selectedLanguages?.length)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              closable: false,
              severity: "warn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.message.noLanguages")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isEditingExpertLanguages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedLanguages, (language) => {
                return (_openBlock(), _createBlock(_component_Chip, {
                  key: language,
                  class: "mr-1 mb-1 p-chip-secondary",
                  label: language
                }, null, 8, ["label"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("label", null, _toDisplayString(`${_ctx.$t("myCadac.expertSettings.selectLanguage")}`), 1),
              (_ctx.isEditingExpertLanguages)
                ? (_openBlock(), _createBlock(_component_MultiSelect, {
                    key: 0,
                    modelValue: _ctx.selectedLanguages,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedLanguages) = $event)),
                    display: "chip",
                    filter: false,
                    "option-label": "value",
                    "option-value": "value",
                    options: _ctx.vm.languageOptions,
                    placeholder: _ctx.$t('myCadac.expertSettings.selectLanguage_placeholder'),
                    "show-toggle-all": false
                  }, {
                    value: _withCtx((slotProps) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.value, (language) => {
                        return (_openBlock(), _createBlock(_component_Chip, {
                          key: language,
                          class: "mr-1 p-chip-primary",
                          label: language
                        }, null, 8, ["label"]))
                      }), 128)),
                      (!slotProps.value || slotProps.value.length === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.selectLanguage_placeholder")), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.option.value), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_Button, {
                  class: "",
                  label: _ctx.$t(`common.save`),
                  onClick: _ctx.saveExpertLanguages
                }, null, 8, ["label", "onClick"])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { class: "mb-2" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.$t("myCadac.expertSettings.titleExpertises")), 1)
        ])
      ]),
      icons: _withCtx(() => [
        (!_ctx.isEditingExpertises)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-text",
              icon: "pi pi-pencil",
              label: _ctx.$t('common.edit'),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isEditingExpertises = true))
            }, null, 8, ["label"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "p-button-text p-button-primary",
              label: _ctx.$t('common.cancel'),
              onClick: _cache[10] || (_cache[10] = ($event: any) => {
					_ctx.isEditingExpertises = false;
					_ctx.initExpertises();
				})
            }, null, 8, ["label"]))
      ]),
      default: _withCtx(() => [
        (!_ctx.isEditingExpertises && !_ctx.selectedExpertises?.length)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              closable: false,
              severity: "warn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.message.noExpertises")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isEditingExpertises)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedExpertises, (expertise) => {
                return (_openBlock(), _createBlock(_component_Chip, {
                  key: expertise.name,
                  class: "mr-1 mb-1 p-chip-secondary",
                  label: expertise.name
                }, null, 8, ["label"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, _toDisplayString(`${_ctx.$t("myCadac.expertSettings.selectExpertises")}`), 1),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_AutoComplete, {
                  modelValue: _ctx.selectedExpertises,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedExpertises) = $event)),
                  "force-selection": "",
                  "min-length": 2,
                  multiple: true,
                  "option-label": "name",
                  placeholder: _ctx.$t('myCadac.expertSettings.selectExpertises_placeholder'),
                  suggestions: _ctx.searchExpertiseResults,
                  onComplete: _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchExpertises($event)))
                }, {
                  option: _withCtx(({ option }) => [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("p", _hoisted_42, _toDisplayString(option?.name), 1),
                      _createElementVNode("p", _hoisted_43, "(" + _toDisplayString(option?.category) + ")", 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "suggestions"]),
                _hoisted_44
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_Button, {
                  class: "",
                  label: _ctx.$t(`common.save`),
                  onClick: _ctx.saveExpertExpertises
                }, null, 8, ["label", "onClick"])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { class: "mb-2" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.$t("myCadac.expertSettings.titleExperience")), 1)
        ])
      ]),
      icons: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-text px-0",
          icon: "pi pi-plus",
          label: _ctx.$t('common.add'),
          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.onAddExperienceClick()), ["stop"]))
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        (_ctx.expertExperiences?.length)
          ? (_openBlock(), _createBlock(_component_Accordion, {
              key: 0,
              "active-index": _ctx.experiencesActiveTabIndexes,
              "onUpdate:activeIndex": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.experiencesActiveTabIndexes) = $event)),
              multiple: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expertExperiences, (experience) => {
                  return (_openBlock(), _createBlock(_component_AccordionTab, { key: experience }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("p", _hoisted_50, _toDisplayString(experience.title), 1)
                        ])
                      ]),
                      (!_ctx.editingExperiences[experience.id])
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "p-button-outlined p-button-rounded border",
                            icon: "pi pi-pencil",
                            onClick: _withModifiers(($event: any) => (_ctx.editingExperiences[experience.id] = true), ["stop"])
                          }, null, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "p-button-text",
                            label: _ctx.$t('common.cancel'),
                            onClick: _withModifiers(($event: any) => (_ctx.editingExperiences[experience.id] = false), ["stop"])
                          }, null, 8, ["label", "onClick"])),
                      (!_ctx.editingExperiences[experience.id])
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 2,
                            class: "p-button-danger p-button-outlined p-button-rounded border",
                            icon: "pi pi-times",
                            onClick: _withModifiers(($event: any) => (_ctx.confirmRemoveExperience(experience)), ["stop"])
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_ExpertExperienceForm, {
                        "is-editing": _ctx.editingExperiences[experience.id],
                        vm: experience,
                        onSubmit: _ctx.saveExpertExperience
                      }, null, 8, ["is-editing", "vm", "onSubmit"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-index"]))
          : (_openBlock(), _createBlock(_component_Message, {
              key: 1,
              closable: false,
              severity: "warn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.message.noExperiences")), 1)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { class: "mb-2" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("h3", _hoisted_52, _toDisplayString(_ctx.$t("myCadac.expertSettings.titleCertifications")), 1)
        ])
      ]),
      icons: _withCtx(() => [
        (!_ctx.isEditingCertifications)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-text",
              icon: "pi pi-pencil",
              label: _ctx.$t('common.edit'),
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isEditingCertifications = true))
            }, null, 8, ["label"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "p-button-text",
              label: _ctx.$t('common.cancel'),
              onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => {
					_ctx.isEditingCertifications = false;
					_ctx.initCertifications();
				}, ["stop"]))
            }, null, 8, ["label"]))
      ]),
      default: _withCtx(() => [
        (_ctx.isEditingCertifications)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("label", null, _toDisplayString(`${_ctx.$t("myCadac.expertSettings.selectCertifications")}`), 1),
              (_ctx.isEditingCertifications)
                ? (_openBlock(), _createBlock(_component_MultiSelect, {
                    key: 0,
                    modelValue: _ctx.selectedCertifications,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedCertifications) = $event)),
                    filter: false,
                    "option-label": "label",
                    "option-value": "value",
                    options: _ctx.availableCertifications,
                    placeholder: _ctx.$t('myCadac.expertSettings.selectCertifications_placeholder'),
                    "show-toggle-all": false
                  }, {
                    value: _withCtx((slotProps) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.value, (certification) => {
                        return (_openBlock(), _createBlock(_component_Chip, {
                          key: certification,
                          class: "mr-1 p-chip-primary",
                          label: certification.level
                        }, null, 8, ["label"]))
                      }), 128)),
                      (!slotProps.value || slotProps.value.length === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.selectCertifications_placeholder")), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("p", null, _toDisplayString(slotProps.option.label), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_Button, {
                  label: _ctx.$t(`common.save`),
                  onClick: _ctx.saveExpertCertifications
                }, null, 8, ["label", "onClick"])
              ])
            ]))
          : (_ctx.selectedCertifications?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCertifications, (certification) => {
                  return (_openBlock(), _createBlock(_component_Chip, {
                    key: certification,
                    class: "mr-1 mb-1 p-chip-primary",
                    label: certification.level
                  }, null, 8, ["label"]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(_component_Message, {
                key: 2,
                closable: false,
                severity: "warn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("myCadac.expertSettings.message.noCertifications")), 1)
                ]),
                _: 1
              }))
      ]),
      _: 1
    }),
    (_ctx.expertStore.isLevelModalVisible)
      ? (_openBlock(), _createBlock(_component_ExpertLevelModal, {
          key: 1,
          "current-level": _ctx.expertProfile?.expertLevelProduct,
          options: _ctx.vm.allExpertLevelProducts,
          "requested-level": _ctx.expertProfile?.requestedLevelProduct,
          onLevelSelected: _ctx.saveExpertLevel
        }, null, 8, ["current-level", "options", "requested-level", "onLevelSelected"]))
      : _createCommentVNode("", true)
  ], 64))
}